import React, { useContext } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';

import { NewContext } from '../../../Context/NewContext';

import './header.css';

export const Header = ({ title, previewLink = `/preview`, addLink, deleteUpdateTag, isLoadMoreShow = false }) => {
    // console.log(addLink, previewLink);
    const navigate = useNavigate();
    const { search, setSearch, setCurrentPage, isLoadMore, checkedValues, handleDeleteAll, handleIsLoadMoreSwitch } = useContext(NewContext);

    return (
        <div className='table-header mb-3 d-flex justify-content-between align-items-center flex-wrap'>
            <div className='d-flex align-items-center'>
                <div className='title pe-3'>
                    <h5>{title}</h5>
                </div>
                <div className='d-flex align-items-center'>
                    {
                        deleteUpdateTag &&
                        <div className={`px-3 border-start ${isLoadMoreShow && `border-end`} border-dark`}>
                            <Button variant='outline-danger' className='p-1 cursor-pointer' onClick={() => handleDeleteAll(deleteUpdateTag)} disabled={checkedValues?.length === 0}>
                                <MdDelete size={"18px"} />
                            </Button>
                        </div>
                    }
                    {
                        isLoadMoreShow &&
                        <div className='px-3'>
                            <label htmlFor='isLoadMore' className='fs-7'>Recommended Loading</label>
                            <Form.Check type="switch" id="isLoadMore" name='isLoadMore' onChange={handleIsLoadMoreSwitch} checked={isLoadMore} role="button" />
                        </div>
                    }
                </div>
            </div>
            <div className='d-flex flex-wrap'>
                <Form.Control
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    className='mb-2 mb-sm-0 table-search fs-7'
                    value={search}
                    onChange={(e) => { setSearch(e.target.value); setCurrentPage(1) }}
                />
                <Link to={previewLink} target='_blank'>
                    <Button className="mx-0 mx-sm-3 me-3 table-preview h-100 fs-7" variant="primary">Preview</Button>
                    {/* onClick={() => navigate(previewLink)} */}
                </Link>
                {addLink && <Button className="table-add fs-7" variant="secondary" onClick={() => navigate(addLink)}>Add {title}</Button>}
            </div>
        </div>
    )
}

export default Header